import { useEffect } from 'react'
import { Controller, useFieldArray } from 'react-hook-form'

import SuggestionField from '../../contacts/form/SuggestionField'

const ProprietaireFields = ({control, formErrors, apiErrors}) => {

  // Utilisation de useFieldArray pour gérer un tableau de propriétaires
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "proprietaires",
    keyName: "fieldId" // Utiliser un nom différent pour éviter les conflits avec l'id des propriétaires
  })

  // Récupérer les valeurs actuelles du formulaire pour les propriétaires
  const proprietairesValue = control._formValues?.proprietaires || []
  
  // Assurons-nous qu'il y a au moins un champ vide si aucun propriétaire n'est défini
  useEffect(() => {
    if (fields.length === 0 && proprietairesValue.length === 0) {
      // Aucun propriétaire, ajouter un champ vide
      append({ contact_id: '' })
    } else if (proprietairesValue.length > 0 && fields.length === 0) {
      // Des propriétaires existent dans le formulaire mais pas dans fields
      // Cela peut arriver lors de l'initialisation
      replace(proprietairesValue)
    }
  }, [fields.length, proprietairesValue.length, append, replace, proprietairesValue])

  // Fonction utilitaire pour obtenir l'erreur combinée (du form ou de l'API)
  const getErrorMessage = (fieldName) => 
    formErrors?.[fieldName]?.message || apiErrors?.[fieldName] || ''

  // Fonction utilitaire pour déterminer si un champ a une erreur
  const hasError = (fieldName) => 
    !!formErrors?.[fieldName] || !!apiErrors?.[fieldName]    
      
  return (
    <>
      {fields.map((values, index) => (
        <div key={index} className="mb-4 relative flex justify-end items-center">
          {/* Afficher le bouton de suppression seulement s'il y a plus d'un propriétaire */}
          {fields.length > 1 && (
            <button 
              type="button"
              className="btn btn-circle btn-xs btn-ghost bg-base-200 hover:bg-base-300 mr-4"
              onClick={() => remove(index)}
              title="Supprimer ce propriétaire"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14" />
              </svg>
            </button>
          )}

          <div className="w-full">
            <Controller
              name={`proprietaires.${index}`}
              control={control}
              render={({ field }) => (
                <SuggestionField
                  contactField={field}
                  originalData={values}
                  hasError={hasError(`proprietaires.${index}`)} 
                  errorMessage={getErrorMessage(`proprietaires.${index}`)}
                  label={`Propriétaire ${index + 1}`}
                />
              )}
            />
          </div> 
        </div>
      ))}
      
      {/* Bouton pour ajouter un nouveau propriétaire */}
      <div className="flex flex-col space-x-2">
        <button
          type="button"
          className="btn btn-outline new-owner"
          onClick={() => append({ contact_id: '' })}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Ajouter un propriétaire existant
        </button>         
      </div>
    </>
  )
}

export default ProprietaireFields